import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { c as o } from "./index-65016bfa.mjs";
import b from "react";
import n, { css as a } from "styled-components";
import { useTheme as O, ThemeName as k } from "@fcamna/shared-component-foundations";
import { u as q } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as D } from "./icon.js";
import { TagsGroup as K, Tag as M } from "./tags.js";
import { u as Q } from "./useAccessibilityProps-2f24cf29.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./childrenCountCheck-785fa19a.mjs";
const B = n.div`
  &.ListWrapper {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.ListWrapper)};
  }
`, J = n.div`
  &.ListContent {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.ListContent)};
  }
`, U = n.div`
  &.LeadingElementWrapper {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.LeadingElementWrapper)};
  }
`, V = n.div`
  &.TagsAndContentWrapper {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.TagsAndContent)};
  }
`, P = n.div`
  &.SecondaryContent {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.SecondaryContent)};
  }
`, x = n.div`
  &.SecondaryIconWrapper {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.SecondaryIconWrapper)};
  }
`, X = n.div`
  &.PrimaryContent {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.PrimaryContent)};
  }
`, Y = n.div`
  &.Rule {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.Rule)};
  }
`, R = n.div`
  &.TrailingElementWrapper {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.TrailingElementWrapper)};
  }
`, w = ({
  label: e,
  description: g,
  leadingElement: W,
  leadingElementSize: h = "l",
  trailingElement: m,
  trailingElementAlignment: c = "center",
  secondaryIcon: L,
  eyebrowProps: y,
  tagProps: v,
  isStatic: $ = !1,
  _selectHandler: i,
  _type: l = "action",
  _static: s = !1,
  _hasRule: f = !1,
  className: r,
  isActive: C = !1,
  swapLabels: E = !1,
  accessibilityOptions: I = {},
  value: S
}) => {
  const T = s || $, { tagGroupProps: A, tagsData: u } = v || {}, { eyebrowText: F, eyebrowIcon: N } = y || {}, { themeName: j } = O(), z = Q("listitem", {
    ...I
  });
  return /* @__PURE__ */ d("li", { children: [
    /* @__PURE__ */ t(
      B,
      {
        tabIndex: T ? void 0 : 0,
        onKeyDown: (p) => {
          (p.code === "Space" || p.code === "Enter") && i && i(p, e, S);
        },
        className: o([
          "ListWrapper",
          r,
          `ListWrapper--${l}`,
          { "ListWrapper--active": C },
          { "ListWrapper--static": T },
          { "ListWrapper--rule": f },
          { "ListWrapper--event": !!i }
        ]),
        onClick: (p) => i && i(p, e, S),
        ...z,
        children: /* @__PURE__ */ d("div", { children: [
          W && /* @__PURE__ */ t(
            U,
            {
              className: o(["LeadingElementWrapper", r, `LeadingElementWrapper--${h}`]),
              children: W
            }
          ),
          /* @__PURE__ */ d(
            V,
            {
              tabIndex: -1,
              className: o(["TagsAndContentWrapper", r]),
              children: [
                u && (u == null ? void 0 : u.length) > 0 && /* @__PURE__ */ t(
                  K,
                  {
                    overflow: !0,
                    visibleTags: 1,
                    ...A,
                    children: u.map((p, G) => /* @__PURE__ */ t(
                      M,
                      {
                        ...p
                      },
                      G
                    ))
                  }
                ),
                /* @__PURE__ */ d(P, { className: "SecondaryContent", children: [
                  N && /* @__PURE__ */ t(x, { className: "SecondaryIconWrapper", children: N }),
                  F
                ] }),
                /* @__PURE__ */ d(
                  J,
                  {
                    tabIndex: -1,
                    className: o([r, "ListContent", { "ListContent--swapLabels": E }]),
                    children: [
                      /* @__PURE__ */ t(X, { className: "PrimaryContent", children: /* @__PURE__ */ t("div", { className: "title", children: e }) }),
                      /* @__PURE__ */ d(P, { className: "SecondaryContent", children: [
                        L && /* @__PURE__ */ t(x, { className: "SecondaryIconWrapper", children: L }),
                        g
                      ] })
                    ]
                  }
                )
              ]
            }
          ),
          m ? m !== "none" ? /* @__PURE__ */ t(
            R,
            {
              className: o(["TrailingElementWrapper", r, `TrailingElementWrapper--${c}`]),
              children: m
            }
          ) : null : !T && j === k.FORD_PRO ? /* @__PURE__ */ t(
            R,
            {
              className: o([
                "TrailingElementWrapper",
                r,
                `TrailingElementWrapper--${c}`,
                { "TrailingElementWrapper--padding": !0 }
              ]),
              children: /* @__PURE__ */ t(
                D,
                {
                  name: "caretRightFilled",
                  size: "m"
                }
              )
            }
          ) : /* @__PURE__ */ t(
            R,
            {
              className: o(["TrailingElementWrapper", r, `TrailingElementWrapper--${c}`]),
              children: /* @__PURE__ */ t(
                D,
                {
                  name: "caretRight",
                  size: "s"
                }
              )
            }
          )
        ] })
      }
    ),
    f && l !== "boxed" && /* @__PURE__ */ t(
      Y,
      {
        className: o(["Rule", r, `Rule--${l}`, { "Rule--active": C }, { "Rule--static": T }])
      }
    )
  ] });
}, Z = n.ul`
  &.DataList {
    ${({
  theme: {
    components: { dataList: e }
  }
}) => a(e.DataList)};
  }
`, _ = ({
  children: e,
  uniqueIdentifier: g,
  ariaLabel: W,
  onChange: h = null,
  type: m = "default",
  isStatic: c = !1,
  className: L,
  hasRule: y = !1
}) => {
  const v = q({ label: "Data List" }), $ = (i) => {
    let l = !0;
    return b.Children.map(i, (s) => {
      if ((s == null ? void 0 : s.type) === w) {
        const f = s.props;
        let r = !1;
        return f.isActive && l && (r = !0, l = !1), b.cloneElement(s, {
          _type: m,
          _selectHandler: !c && h ? (C, E, I) => h(C, E, I) : null,
          isActive: r,
          _hasRule: y,
          _static: c
        });
      }
      return null;
    });
  };
  return /* @__PURE__ */ t(
    Z,
    {
      "aria-label": W,
      className: o([L, "DataList", `DataList--${m}`]),
      id: g,
      ...v,
      children: $(e)
    }
  );
};
_.Item = w;
export {
  _ as DataList
};
